module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('skirental.wishes.pick')))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "1.5rem",
      "margin-top": "1rem"
    }
  }, [_vm._v("Du kan välja flera. Om du inte har några särskilda önskemål, välj det nedan.")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex"
  }, _vm._l((_vm.getWishes()), function(wish) {
    return _c('div', {
      key: wish.key
    }, [_c('Checkbox', {
      attrs: {
        "label": wish.label,
        "label-position": "right",
        "value": true,
        "valuebinder": _vm.wishes[wish.key],
        "type": "checkbox",
        "special-class": "wishes"
      },
      on: {
        "update:valuebinder": function($event) {
          return _vm.$set(_vm.wishes, wish.key, $event)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "multi"
  }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.other')))]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "width": "100%",
      "max-width": "500px"
    }
  }, [_c('div', {
    staticClass: "full"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('skirental.wishes.other-help')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wishes.freeText),
      expression: "wishes.freeText"
    }],
    staticClass: "text-input",
    attrs: {
      "rows": "2"
    },
    domProps: {
      "value": (_vm.wishes.freeText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.wishes, "freeText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "small",
    on: {
      "click": _vm.clicked
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.wishes.save')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca6b52e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/SkiSchoolWishes.vue
// module id = 1023
// module chunks = 0